import { render, staticRenderFns } from "./BettingBot.vue?vue&type=template&id=7216b5de&scoped=true&"
import script from "./BettingBot.vue?vue&type=script&lang=js&"
export * from "./BettingBot.vue?vue&type=script&lang=js&"
import style0 from "./BettingBot.vue?vue&type=style&index=0&id=7216b5de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7216b5de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
